import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createCompressor from 'redux-persist-transform-compress';
import { LoginType } from 'src/utilities/_enums';

type NullableString = string | null;

export interface AppState {
  clientId: NullableString;
  accessToken: NullableString;
  refreshToken: NullableString;
  expires: Date | null;
  idToken: NullableString;
  loginType: LoginType | null;
  clients: AuthClient[] | null;
}

interface AuthClient {
  description: string;
  apiClientID: string;
  clientId: number;
  id: number;
}

interface AuthPayload {
  expires: Date | null;
  accessToken: string;
  refreshToken: string;
  idToken?: string;
  loginType?: LoginType;
  clients?: AuthClient[];
}

const initialState: AppState = {
  clientId: null,
  accessToken: null,
  refreshToken: null,
  expires: null,
  idToken: null,
  loginType: null,
  clients: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setClientId: (state, action: PayloadAction<string>) => {
      state.clientId = action.payload;
    },
    logOut: (state) => {
      state.accessToken = null;
      state.expires = null;
      state.refreshToken = null;
      state.idToken = null;
      state.loginType = null;
      state.clients = [];
    },
    setAuth: (state, action: PayloadAction<AuthPayload>) => {
      const { accessToken, refreshToken, expires, clients, loginType, idToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.expires = expires;
      state.loginType = loginType ?? state.loginType;
      state.idToken = idToken ?? null;
      state.clients = clients ?? [];
    },
  },
});

export const appSliceActions = appSlice.actions;
export const appSliceReducer = persistReducer<AppState>(
  {
    storage,
    timeout: 0,
    blacklist: [],
    key: 'app',
    debug: true,
    transforms: [createCompressor()],
  },
  appSlice.reducer
);
// export const appSliceReducer = appSlice.reducer;
